import http from './http'
let url = 'Documento/'
export function getTermoAcordo(payload) {
    return http.get(url + 'divida/' + payload.chaveDivida + '/' + payload.codigo)
}
export function getTermoConfissao(payload) {
    return http.get(url + 'negociacao/' + payload.chaveNegociacao + '/' + payload.parcela + '/' + payload.codigo)
}